<template>
  <div style="width: 100%">
    <el-table border size="mini" :data="datas" style="width: 100%">
      <el-table-column
        fixed="left"
        prop="Code"
        label="客户编号"
        min-width="120"
      >
      </el-table-column>
      <el-table-column prop="Name" fixed="left" label="姓名" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.RealName
          }}<el-tag type="warning">@{{ scope.row.Actor.Name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Mobile"
        fixed="left"
        label="手机号"
        min-width="100"
      >
      </el-table-column>
      <el-table-column prop="Sex" label="性别" width="60"> </el-table-column>
      <el-table-column prop="Birthday" label="年龄" width="60">
        <template slot-scope="scope">
          <span>{{
            format.getAgeByDateString(format.dateFormat(scope.row.Birthday))
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="IdCode" label="身份证号" width="150">
      </el-table-column>
      <el-table-column prop="Height" label="身高" width="60"> </el-table-column>
      <el-table-column prop="Weight" label="体重" width="60"> </el-table-column>
      <el-table-column prop="ShoesSize" label="鞋码" width="100">
      </el-table-column>
      <el-table-column prop="BMI" label="BMI" width="60">
        <template slot-scope="scope">
          {{ scope.row.BMI.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="FatRate" label="体脂率" width="100">
      </el-table-column>
      <el-table-column prop="BloodPressureMin" label="血压" width="120">
        <template slot-scope="scope">
          {{ scope.row.BloodPressureMin }}-
          {{ scope.row.BloodPressureMax }}
        </template>
      </el-table-column>
      <el-table-column prop="InsertTime" label="注册时间" min-width="100">
        <template slot-scope="scope">
          {{ format.dateFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
       <el-table-column prop="RunGroupNames" label="加入跑团" min-width="100">
      </el-table-column>
      <el-table-column
        prop="CheckSelfHeart.AcceptableStatus"
        label="心血管筛查结果"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            type="info"
            v-if="scope.row.CheckSelfHeart.AcceptableStatus == 0"
            >未评估</el-tag
          >
          <el-tag
            type="success"
            v-if="scope.row.CheckSelfHeart.AcceptableStatus == 10"
            >低危</el-tag
          >
          <el-tag
            type="danger"
            v-if="scope.row.CheckSelfHeart.AcceptableStatus == 20"
            >高危</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="CheckSelfIKDC.IKDCScore"
        label="IKDC自测结果"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-tag
            type="warning"
            v-if="scope.row.CheckSelfIKDC && scope.row.CheckSelfIKDC.Key"
            >{{ scope.row.CheckSelfIKDC.IKDCScore }}/{{
              scope.row.CheckSelfIKDC.IKDCResult
            }}</el-tag
          >
          <el-tag type="info" v-else>未评估</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="CheckSelfVAS.Count"
        label="VAS自测结果"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            type="warning"
            v-if="scope.row.CheckSelfVAS && scope.row.CheckSelfVAS.Key"
            >{{ scope.row.CheckSelfVAS.Count }}处疼痛</el-tag
          >
          <el-tag type="info" v-else>未评估</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :width="160" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="update(scope.row)">修改</el-button>
          <el-button type="text" @click="showAnswner(scope.row)"
            >查看问卷</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      background
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page.sync="pageIndex"
    ></el-pagination>
    <customerForm ref="customerForm" @update="getData"></customerForm>
    <answerViewer ref="answerViewer" />
  </div>
</template>
<script>
import { getPageListCustomer } from "@/api/setting/member.js";
import customerForm from "./customerForm.vue";
import answerViewer from "./answerViewer.vue";

export default {
  components: { customerForm, answerViewer },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.pageIndex = 1;
        this.getData();
      },
    },
  },
  data() {
    return {
      datas: [],
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      pageSizeList: [10, 20, 30, 40, 50],
    };
  },

  methods: {
    getData() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      getPageListCustomer(this.filter).then((res) => {
        this.datas = res.Items;
        this.total = res.Total || res.Items.length;
      });
    },
    create() {
      this.$refs.customerForm.handleCreate();
    },
    update(row) {
      let json = JSON.parse(JSON.stringify(row));
      this.$refs.customerForm.handleEdit(json);
    },
    showAnswner(row) {
      this.$refs.answerViewer.show(row, "Heart");
    },
    pageSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getData());
    },
    pageCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.getData();
    },
  },
  mounted() {},
};
</script>
<style lang='scss' scoped>
.status {
  align-self: flex-end;
  font-size: 12px;
  font-weight: bold;
  color: #ff862f;
}
.statusdesc {
  align-self: flex-end;
  font-size: 12px;
  color: #797878;
}
</style>